/* =============================================================================
   LOOMA — search overlay (spec §4.7)
   <looma-search> full-screen overlay: open/close, focus-trap, debounced 250ms
   predictive search (Section Rendering), trending + recent (localStorage).
   No-JS safe: header trigger is <a href="/search">; overlay form GETs /search.
   ========================================================================== */
(function () {
  'use strict';

  var RECENT_KEY = 'looma:recent';
  var MAX_RECENT = 6;
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function pushRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  if (!customElements.get('looma-search')) {
    customElements.define('looma-search', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.search-ov__panel');
        this.input = this.querySelector('[data-search-input]');
        this.form = this.querySelector('[data-search-form]');
        this.results = this.querySelector('[data-search-results]');
        this.intro = this.querySelector('[data-search-intro]');
        this.clearBtn = this.querySelector('[data-search-clear]');
        this._opener = null;
        this._t = null;
        this._onKey = this._onKey.bind(this);
        var self = this;

        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-search-close]')) { e.preventDefault(); self.close(); return; }
          var term = e.target.closest('[data-search-term]');
          if (term) {
            self.input.value = term.dataset.searchTerm;
            self._run();
            self.input.focus();
            return;
          }
          if (e.target.closest('[data-recent-clear]')) {
            try { localStorage.removeItem(RECENT_KEY); } catch (er) {}
            self._renderRecent();
            return;
          }
          var go = e.target.closest('a[href]');
          if (go && !go.closest('[data-search-intro]')) pushRecent(self.input.value);
        });

        if (this.input) {
          this.input.addEventListener('input', function () {
            if (self.clearBtn) self.clearBtn.hidden = !self.input.value;
            clearTimeout(self._t);
            self._t = setTimeout(function () { self._run(); }, 250);
          });
        }
        if (this.form) {
          this.form.addEventListener('submit', function () { pushRecent(self.input.value); });
          this.form.addEventListener('reset', function () {
            setTimeout(function () { self._run(); self.input.focus(); }, 0);
          });
        }

        document.addEventListener('click', function (e) {
          var trig = e.target.closest('[data-search-trigger]');
          if (trig) { e.preventDefault(); self.open(); }
        });
      }

      open() {
        if (this.classList.contains('is-open')) return;
        this._opener = document.activeElement;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        document.addEventListener('keydown', this._onKey);
        this._renderRecent();
        var self = this;
        setTimeout(function () { if (self.input) self.input.focus(); }, 60);
      }
      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        document.removeEventListener('keydown', this._onKey);
        if (this._opener && this._opener.focus) this._opener.focus();
      }

      _run() {
        var q = (this.input && this.input.value || '').trim();
        if (this.clearBtn) this.clearBtn.hidden = !q;
        if (q.length < 2) {
          this.results.innerHTML = '';
          if (this.intro) this.intro.hidden = false;
          return;
        }
        if (this.intro) this.intro.hidden = true;
        var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
        var url = base + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,article,page&resources[limit]=6';
        var self = this;
        this.classList.add('is-loading');
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var payload = doc.querySelector('[data-search-payload]') || doc.body;
            self.results.innerHTML = payload ? payload.innerHTML : '';
          })
          .catch(function () {})
          .then(function () { self.classList.remove('is-loading'); });
      }

      _renderRecent() {
        var wrap = this.querySelector('[data-recent-wrap]');
        var box = this.querySelector('[data-recent]');
        if (!wrap || !box) return;
        var list = readRecent();
        if (!list.length) { wrap.hidden = true; box.innerHTML = ''; return; }
        wrap.hidden = false;
        box.innerHTML = list.map(function (t) {
          var safe = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          return '<button type="button" class="pill-f" data-search-term="' + safe + '">' + safe + '</button>';
        }).join('');
      }

      _onKey(e) {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab' || !this.panel) return;
        var nodes = [].slice.call(this.panel.querySelectorAll(FOCUSABLE))
          .filter(function (n) { return n.offsetParent !== null; });
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
})();
